(() => {
  const ignored = 'script, style, noscript, textarea, option, svg, math, .us-registered-symbol, [contenteditable="true"]';
  function format(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 3)) return;
    if (root.nodeType === 1 && root.closest(ignored)) return;
    const nodes = [];
    if (root.nodeType === 3) nodes.push(root);
    else {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) nodes.push(walker.currentNode);
    }
    nodes.forEach(node => {
      if (!node.textContent.includes('®') || !node.parentElement || node.parentElement.closest(ignored)) return;
      const fragment = document.createDocumentFragment();
      node.textContent.split('®').forEach((part, index) => {
        if (index) {
          const symbol = document.createElement('span');
          symbol.className = 'us-registered-symbol';
          symbol.textContent = '®';
          fragment.appendChild(symbol);
        }
        if (part) fragment.appendChild(document.createTextNode(part));
      });
      node.replaceWith(fragment);
    });
  }
  format(document.body);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'characterData') format(record.target);
      else record.addedNodes.forEach(format);
    });
  }).observe(document.body, { childList: true, characterData: true, subtree: true });
})();